/**
 * `getHireUrgencyBand` — the client half of the unified hire-urgency rule.
 * MIRRORS `server/helpers/hireUrgency.js`'s `hireUrgencyBand` — the server
 * is the authority for the NUMBERS, this file owns the two Tailwind classes
 * (`bg-red-*`/`bg-amber-*`, `border-red-*`/`border-amber-*`,
 * `text-red-*`/`text-amber-*` — chosen at each call site, this module only
 * hands back the band NAME) that are no business of the server. This is
 * **NEVER a gate** — it decides what colour to paint, nothing more.
 *
 * Held in step with `server/helpers/hireUrgency.js` by
 * `server/tests/api/hire-urgency-bands.test.js` §4, which reads the two
 * `if (days <= N)` guards below as TEXT and fails on drift — the same
 * device `slack-bands.test.js` uses for `LeadTimeRisk.js`'s
 * `getLeadTimeBand`. If you retune a threshold, retune BOTH files in the
 * same commit.
 *
 * Owner ruling, 2026-08-18: "I think red should mean late or today. amber
 * is close."
 *   RED   — `hireStatus === 'overdue'`, OR `days <= 0`
 *   AMBER — `days` 1..5 inclusive
 *   null  — `days > 5`, or unknown (`null`/`undefined`/non-finite)
 *
 * 🚨 `days === 0` MUST be red — never `!days`, which would treat a
 * same-day return as "no information". 🚨 `null`/`undefined`/`NaN` is a
 * THIRD state, never zero — an unknown return date renders nothing.
 *
 * @param {number|null|undefined} days days until the hire's `hire_to`
 *   date; may be negative. Ignored when `hireStatus === 'overdue'`.
 * @param {string|null|undefined} hireStatus the hire item's `hire_status`.
 * @returns {'red'|'amber'|null}
 */
export function getHireUrgencyBand(days, hireStatus) {
  if (hireStatus === 'overdue') return 'red';
  if (days === null || days === undefined || !Number.isFinite(days)) return null;
  if (days <= 0) return 'red';
  if (days <= 5) return 'amber';
  return null;
}
